import React, { useRef } from 'react';

//components
import TooltipDropdownList from  '@/components/elements/global/dropdown/TooltipDropdownList';

//interfaces
import { useClickAwayClose } from  '@/components/hooks/utility/useClickAwayClose';
import UseUserRoleGroups from './userRoleGroups.hooks';

//styling
import "../../../../../css/global/orgSettings/userRoleGroups.scss";



const UserRoleGroups = ({id, userRole}: {id: any, userRole: string}) => {
    const {isLoading, groups, displayTooltip, setDisplayTooltip, extraDetailText} = UseUserRoleGroups(id);
    const dropdownRef = useRef<any>();

    useClickAwayClose(displayTooltip, dropdownRef, ()=> setDisplayTooltip(false));

    return (
        <div className='user-role-groups-container' ref={dropdownRef} onMouseEnter={() => setDisplayTooltip(true)} onMouseLeave={() => setDisplayTooltip(false)}>
            <button className='user-role-groups-button' onClick={() => setDisplayTooltip(true)}>
                {userRole}
            </button>

            <TooltipDropdownList show={displayTooltip} isLoading={isLoading} items={groups} extraDetailText={extraDetailText}/>
        </div>
    )
}

export default UserRoleGroups